import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.css";
import "./styles/win95.css";
import "./styles/landing.css";
import "./styles/tutor.css";
import "./styles/auth.css";
import "./styles/admin.css";
import "./styles/battle.css";
import "./styles/profile.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
